"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var fetch = require("isomorphic-fetch");
var constants_1 = require("./constants");
var Modal = require("react-modal");
var graphcool_styles_1 = require("graphcool-styles");
var Table_1 = require("./SelectUserPopup/Table");
var SearchBox_1 = require("./GraphiQL/DocExplorer/SearchBox");
var Immutable = require("seamless-immutable");
var SelectUserPopup = function (_super) {
    __extends(SelectUserPopup, _super);
    function SelectUserPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRowSelection = function (_a) {
            var index = _a.index,
                rowData = _a.rowData;
            if (index === _this.state.selectedRowIndex) {
                return;
            }
            _this.setState(function (state) {
                var users = state.users;
                if (state.selectedRowIndex > -1) {
                    users = Immutable.setIn(users, [state.selectedRowIndex, 'selected'], false);
                }
                users = Immutable.setIn(users, [index, 'selected'], true);
                return __assign({}, state, { users: users, selectedRowIndex: index });
            });
            _this.props.onSelectUser(rowData);
        };
        _this.handleSearch = function (value) {
            _this.setState({ query: value }, function () {
                var _a = _this.state,
                    startIndex = _a.startIndex,
                    stopIndex = _a.stopIndex;
                _this.getUsers({ startIndex: startIndex, stopIndex: stopIndex });
            });
        };
        _this.getUsers = function (_a, userFieldsInput) {
            var startIndex = _a.startIndex,
                stopIndex = _a.stopIndex;
            var query = _this.state.query;
            var userFields = userFieldsInput || _this.props.userFields;
            if (userFields.length === 0) {
                return;
            }
            var filter = '';
            if (query && query.length > 0) {
                filter = ' filter: { OR: [';
                var whiteList_1 = ['ID', 'String', 'Enum'];
                var filtered = userFields.filter(function (field) {
                    var typeName = field.type.name || field.type.ofType.name;
                    return whiteList_1.indexOf(typeName) > -1;
                });
                filter += filtered.map(function (field) {
                    return "{" + field.name + "_contains: \"" + query + "\"}";
                }).join(',\n');
                filter += ']}';
            }
            var count = stopIndex - startIndex;
            var userQuery = "\n      {\n        _allUsersMeta {\n          count\n        }\n        allUsers(skip: " + startIndex + " first: " + count + filter + "){\n          " + userFields.map(function (f) {
                return f.name;
            }).join('\n') + "\n        }\n      }\n    ";
            fetch(_this.props.endpointUrl, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + _this.props.adminAuthToken,
                    'X-GraphCool-Source': 'playground'
                },
                body: JSON.stringify({ query: userQuery })
            }).then(function (res) {
                return res.json();
            }).then(function (res) {
                if (!res.data) {
                    return;
                }
                var _a = res.data,
                    _allUsersMeta = _a._allUsersMeta,
                    allUsers = _a.allUsers;
                var users = _this.state.users;
                // reset data if search changed
                if (query !== _this.lastQuery) {
                    users = Immutable([]);
                }
                allUsers.forEach(function (user, i) {
                    users = Immutable.set(users, i + startIndex, user);
                });
                var newState = {
                    users: users,
                    count: _allUsersMeta.count
                };
                if (_this.lastQuery !== _this.state.query) {
                    newState['scrollToIndex'] = 0;
                    setTimeout(function () {
                        _this.setState({
                            scrollToIndex: undefined
                        });
                    }, 150);
                }
                _this.setState(newState);
                _this.lastQuery = query;
            }).catch(function (e) {
                return console.error(e);
            });
        };
        _this.state = {
            startIndex: 0,
            stopIndex: 50,
            users: Immutable([]),
            query: '',
            count: 0,
            selectedRowIndex: -1,
            scrollToIndex: undefined
        };
        _this.getUsers({ startIndex: 0, stopIndex: 50 }, props.userFields);
        _this.style = Object.assign({}, constants_1.modalStyle, {
            overlay: constants_1.modalStyle.overlay,
            content: Object.assign({}, constants_1.modalStyle.content, {
                width: 'auto',
                minWidth: '600px',
                maxWidth: window.innerWidth - 100 + 'px'
            })
        });
        global['s'] = _this;
        return _this;
    }
    SelectUserPopup.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.state,
            startIndex = _a.startIndex,
            stopIndex = _a.stopIndex;
        if (nextProps.userFields.length !== this.props.userFields.length) {
            this.getUsers({ startIndex: startIndex, stopIndex: stopIndex }, nextProps.userFields);
        }
    };
    SelectUserPopup.prototype.render = function () {
        // put id to beginning
        return React.createElement(
            Modal,
            { isOpen: this.props.isOpen, onRequestClose: this.props.onRequestClose, contentLabel: "Select a User", style: this.style },
            React.createElement(_style2.default, {
                styleId: 4162553977,
                css: ".title-wrapper[data-jsx=\"1944216071\"] {padding: 45px;}.title[data-jsx=\"1944216071\"] {letter-spacing: 0.54px;}.search[data-jsx=\"1944216071\"] {margin-top: -24px;}.search-box[data-jsx=\"1944216071\"] {-moz-flex: 0 1 400px;-webkit-box-flex: 0;-ms-flex: 0 1 400px;flex: 0 1 400px;}.selected-user-id[data-jsx=\"1944216071\"] {font-family:            'Source Code Pro',            'Consolas',            'Inconsolata',            'Droid Sans Mono',            'Monaco',            monospace;}.bgWhite,\n.select-user-popup[data-jsx=\"1944216071\"] {background-color: #fff;}.relative,\n.select-user-popup[data-jsx=\"1944216071\"] {position: relative;}.mh25,\n.select-user-popup[data-jsx=\"1944216071\"] {margin-left: 25px;margin-right: 25px;}.flex,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {display: -ms-flexbox;display: flex;}.w100,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"] {width: 100%;}.itemsCenter,\n.title-wrapper[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.justifyCenter,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {-ms-flex-pack: center;justify-content: center;}.bb,\n.title-wrapper[data-jsx=\"1944216071\"] {border-bottom-style: solid;border-bottom-width: 1px;}.bBlack10,\n.title-wrapper[data-jsx=\"1944216071\"] {border-color: rgba(0,0,0,.1);}.fw3,\n.title[data-jsx=\"1944216071\"],\n.selected-user-id[data-jsx=\"1944216071\"] {font-weight: 300;}.f38,\n.title[data-jsx=\"1944216071\"] {font-size: 38px;}.absolute,\n.search[data-jsx=\"1944216071\"] {position: absolute;}.w100,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"] {width: 100%;}.bbox,\n.search[data-jsx=\"1944216071\"] {box-sizing: border-box;}.ph38,\n.search[data-jsx=\"1944216071\"] {padding-left: 38px;padding-right: 38px;}.z2,\n.search[data-jsx=\"1944216071\"] {z-index: 2;}.flex,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {display: -ms-flexbox;display: flex;}.justifyCenter,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {-ms-flex-pack: center;justify-content: center;}.ml25,\n.selected-user[data-jsx=\"1944216071\"] {margin-left: 25px;}.flex,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {display: -ms-flexbox;display: flex;}.flexColumn,\n.selected-user[data-jsx=\"1944216071\"] {-ms-flex-direction: column;flex-direction: column;}.justifyCenter,\n.title-wrapper[data-jsx=\"1944216071\"],\n.search[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {-ms-flex-pack: center;justify-content: center;}.itemsCenter,\n.title-wrapper[data-jsx=\"1944216071\"],\n.selected-user[data-jsx=\"1944216071\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.bgBlack04,\n.selected-user-id[data-jsx=\"1944216071\"] {background-color: rgba(0,0,0,.04);}.pa6,\n.selected-user-id[data-jsx=\"1944216071\"] {padding: 6px;}.br2,\n.selected-user-id[data-jsx=\"1944216071\"] {border-radius: 2px;}.black60,\n.selected-user-id[data-jsx=\"1944216071\"] {color: rgba(0,0,0,.6);}.f14,\n.selected-user-id[data-jsx=\"1944216071\"] {font-size: 14px;}.fw3,\n.title[data-jsx=\"1944216071\"],\n.selected-user-id[data-jsx=\"1944216071\"] {font-weight: 300;}.mt10,\n.selected-user-id[data-jsx=\"1944216071\"] {margin-top: 10px;}"
            }),
            React.createElement(_style2.default, {
                styleId: 715398715,
                css: "\n          .absolute,\n.popup-x {\n    position: absolute\n}\n.right0,\n.popup-x {\n    right: 0\n}\n.top0,\n.popup-x {\n    top: 0\n}\n.pointer:hover,\n.popup-x:hover {\n    cursor: pointer\n}\n.pt25,\n.popup-x {\n    padding-top: 25px\n}\n.pr25,\n.popup-x {\n    padding-right: 25px\n}\n        "
            }),
            React.createElement(
                "div",
                { className: "select-user-popup", "data-jsx": 1944216071
                },
                React.createElement(
                    "div",
                    { className: "title-wrapper", "data-jsx": 1944216071
                    },
                    React.createElement(
                        "div",
                        { className: "title", "data-jsx": 1944216071
                        },
                        "Select a User"
                    ),
                    this.state.selectedRowIndex > -1 && React.createElement(
                        "div",
                        { className: "selected-user", "data-jsx": 1944216071
                        },
                        React.createElement(
                            "div",
                            {
                                "data-jsx": 1944216071
                            },
                            "Selected User ID"
                        ),
                        React.createElement(
                            "div",
                            { className: "selected-user-id", "data-jsx": 1944216071
                            },
                            this.state.users[this.state.selectedRowIndex].id
                        )
                    )
                ),
                React.createElement(graphcool_styles_1.Icon, { src: require('graphcool-styles/icons/stroke/cross.svg'), stroke: true, width: 25, height: 25, strokeWidth: 2, className: "popup-x", color: graphcool_styles_1.$v.gray50, onClick: this.props.onRequestClose }),
                React.createElement(
                    "div",
                    { className: "search", "data-jsx": 1944216071
                    },
                    React.createElement(
                        "div",
                        { className: "search-box", "data-jsx": 1944216071
                        },
                        React.createElement(SearchBox_1.default, { placeholder: "Search for a user ...", onSearch: this.handleSearch, isShown: true, clean: true })
                    )
                ),
                React.createElement(Table_1.default, { fields: this.props.userFields, rows: this.state.users, rowCount: this.state.count, loadMoreRows: this.getUsers, onRowSelection: this.handleRowSelection, scrollToIndex: this.state.scrollToIndex })
            )
        );
    };
    return SelectUserPopup;
}(React.Component);
exports.default = SelectUserPopup;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/SelectUserPopup.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/SelectUserPopup.js
// module chunks = 0